<template>
  <v-sheet rounded="xl" width="100%" :dark="false">
    <v-card-title>
      Данные пользователя
    </v-card-title>
    <v-form>
      <v-card-text>

        <div class="d-flex justify-center align-center">
          <v-divider/>
          <div :class="classNameTitleSection">
            Должность<span class="text-h6">*</span>
          </div>
          <v-divider/>
        </div>

        <v-chip-group column class="my-4" v-model="academic_title">
          <v-chip
            v-for="title in academicTitles"
            :key="title.name"
            filter
            outlined
            :value="title.name"
            color="teal darken-3"
          >
            {{title.name}}
          </v-chip>
        </v-chip-group>

        <div class="d-flex justify-center align-center">
          <v-divider/>
          <div :class="classNameTitleSection">
            Ставка<span class="text-h6">*</span>
          </div>
          <v-divider/>
        </div>

        <v-chip-group class="my-4" v-model="bid" column>
          <v-chip
            v-for="bid in bids"
            :key="bid.name"
            filter
            outlined
            filter-icon="fa fa-check"
            :value="bid.name"
            color="teal darken-3"

          >
            {{bid.name}}
          </v-chip>
        </v-chip-group>

        <div class="d-flex justify-center align-center">
          <v-divider/>
          <div :class="classNameTitleSection">
            Дополнительный показатель
          </div>
          <v-divider/>
        </div>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="dean"
              label="Декан"
              color="teal darken-3"
            >
            </v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="head_department"
              label="Заведующий кафедрой"
              color="teal darken-3"
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <v-scroll-y-transition>
          <v-alert v-show="flagErrors" color="error" outlined class="rounded-xl">
            Не выбраны обязательные поля (*)
          </v-alert>
        </v-scroll-y-transition>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="closeForm()"
          elevation="0"
          outlined
          class="rounded-xl"
          color="teal darken-3"
          v-show="orderPresent"
        >
          Отмена
        </v-btn>
        <v-btn
          @click="saveData()"
          color="teal darken-3"
          elevation="0"
          class="rounded-xl white--text"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-sheet>
</template>

<script>
import axios from "axios";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import { createHelpers } from 'vuex-map-fields';


const { mapFields } = createHelpers({
  getterType: 'effective_contract/getPayloadOrderField',
  mutationType: 'effective_contract/updatePayloadOrderField',
});

export default {
  name: "EffConOrderFormDialog",

  props: {
    dialog: Boolean,
  },

  mounted() {
    let bid = 0.1;
    const step = 0.05;

    while(bid < 1.05) {
      this.bids.push({name: bid.toFixed(2)});
      bid += step;
    }
  },

  data() {
    return {

      academicTitles: [
        {name: "Ассистент"},
        {name: "Старший преподаватель"},
        {name: "Доцент"},
        {name: "Профессор"},
      ],

      bids: [],

      flagErrors: false,

      classNameTitleSection: "mx-1 text-subtitle-1 font-weight-bold",

    };
  },

  computed: {

    ...mapFields([
      'bid',
      'academic_title',
      'dean',
      'head_department'
    ]),

  ...mapState({
    orderPresent: state => state.effective_contract.orderPresent,
  }),

  },

  methods: {

    ...mapActions({
      sendEffContract: "effective_contract/sendEffContract",
    }),

    closeForm() {
      this.$router.push("/effective_contracts/app")
    },

    async saveData() {
      try {
        const flagOccupancy = this.bid === null || this.bid === "" || this.academic_title === null || this.academic_title === ""
        if (flagOccupancy) return this.flagErrors = true;

        if (!this.orderPresent) {
          await this.sendEffContract('POST');
        } else {
          await this.sendEffContract('PUT');
        }
        this.flagErrors = false;
        this.dialogOrder = false;
        this.$emit("save-data");
      } catch (err) {
        console.log(err)
      }
    },

  }

}
</script>

<style scoped>

</style>